import setStatic from "./setStatic";
export function setPropTypes(propTypes) {
    return setStatic("propTypes", propTypes);
}
export default setPropTypes;

//# sourceMappingURL=setPropTypes.js.map



//////////////////
// WEBPACK FOOTER
// ./~/reassemble/lib/setPropTypes.js
// module id = 63
// module chunks = 0